import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  ${media.moreThan('smPlus')`
    display: flex;

    > div {
      flex: 1 1 auto;
    }
  `};
`;
